import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex flex-col w-full p-6" }
const _hoisted_4 = { class: "w-full flex flex-row justify-between lg:items-center items-center py-3" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "px-2 py-1 rounded-lg bg-purple-100 text-xs"
}
const _hoisted_7 = { class: "w-full flex lg:flex-row flex-col" }
const _hoisted_8 = { class: "flex flex-row lg:flex-col w-full lg:w-3/12 lg:justify-center justify-start items-center lg:items-start lg:space-y-1 space-x-2 lg:space-x-0 py-0.5 lg:py-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "lg:text-sm lg:text-gray-400 text-sm font-semibold text-gray-700 lg:font-medium" }, "Department", -1)
const _hoisted_10 = { class: "text-sm capitalize" }
const _hoisted_11 = { class: "flex flex-row lg:flex-col w-full lg:w-3/12 lg:justify-center justify-start items-center lg:items-start lg:space-y-1 space-x-2 lg:space-x-0 py-0.5 lg:py-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "lg:text-sm lg:text-gray-400 text-sm font-semibold text-gray-700 lg:font-medium" }, "Location", -1)
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "flex flex-row lg:flex-col w-full lg:w-3/12 lg:justify-center justify-start items-center lg:items-start lg:space-y-1 space-x-2 lg:space-x-0 py-0.5 lg:py-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "lg:text-sm lg:text-gray-400 text-sm font-semibold text-gray-700 lg:font-medium" }, "Work type", -1)
const _hoisted_16 = { class: "text-sm capitalize-letter" }
const _hoisted_17 = { class: "flex flex-row lg:flex-col w-full lg:w-3/12 lg:justify-center justify-start items-center lg:items-start lg:space-y-1 space-x-2 lg:space-x-0 py-0.5 lg:py-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "lg:text-sm lg:text-gray-400 text-sm font-semibold text-gray-700 lg:font-medium" }, "Salary", -1)
const _hoisted_19 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "w-full bg-white shadow-card rounded-2xl mb-4 cursor-pointer transform transition duration-300 zoom-job",
        key: index,
        onClick: ($event: any) => (_ctx.goToJob(_ctx.company, job))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(job.title), 1),
            (job.is_remote)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Remote"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(job.department ? job.department : "Undefined"), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, _toDisplayString(job.job_location?.location
                ? job.job_location?.location?.city +
                  ", " +
                  job.job_location?.location?.state +
                  ", " +
                  job.job_location?.location?.country
                : "Undefined"), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString(job.employment_type
                ? String(job.employment_type).replaceAll("_", " ")
                : "Undefined"), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, "$" + _toDisplayString(job.salary_min ? _ctx.numberWithCommas(job.salary_min) : 0) + " - $" + _toDisplayString(job.salary_max ? _ctx.numberWithCommas(job.salary_max) : 0) + " " + _toDisplayString(job.currency_salary) + " per year ", 1)
            ])
          ])
        ])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}